import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleInfo, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { ChatIcon } from '../../common/components/redesignComponents/ResultPageComponents/v2/ActionIcons';
import { OutlineActionButton, ActionButtonBadge } from '../../common/components/redesignComponents/ResultPageComponents/v2/SecondaryActionButtons.styles';
import { purchase_statues } from '../../common/constants';
import {
  PurchaseStyles,
} from './Purchase.styles';
import {
  ButtonSpinner,
  ConfirmCard,
  DocsCard,
  DocsFooter,
  DocsGrid,
  DocsHeader,
  DocsTitle,
  Notice,
  OptionalBadge,
  OptionalTile,
  Stack,
  StepBadge,
  SubmitDocsButton,
} from './PurchaseV2.styles';
import {
  confirmSelectedForBackofficeQuote,
  motoGetBackofficeUsers,
  purchaseInsuranceRequest,
  resetMotoPurchase,
  updateBrokerage,
} from '../../features/purchases/purchasesActions';
import {
  confirmAlertForBackofficeBrokerQuote,
  generalAlertSuccess,
  generalAlertError,
  confirmAlert,
} from '../../common/utils/alerts';
import { sonnerSuccessAlert } from '../../common/utils/sonnerAlerts';
import OptionalDocumentModal from '../../common/components/elements/OptionalDocumentModal';
import InfoBoxMoto from '../../common/components/redesignComponents/Purchase/common/InfoBoxMoto';
import WaitingForPaymentStatusV2 from '../../common/components/redesignComponents/Purchase/WaitingForPaymentStatusV2';
import {
  apiDeleteOptionalDocument,
  apiDownloadDocument,
  apiDownloadOptionalDocument,
  deleteDocument,
} from '../../services/axios-client/axeCommons';
import uploadIcon from '../../assets/redesign_icons/upload-icon.svg';
import PageLoading from '../../common/componentsV2/elements/PageLoading';
import NonSignableDocumentComponent from './common/NonSignableDocumentComponent';
import NonSIgnableDocumentRequestComponent from './common/NonSIgnableDocumentRequestComponent';
import DocumentsResubmissionWarning from './common/DocumentsResubmissionWarning';
// import CompletedScreenMoto from '../../common/components/elements/PurchaseAuto/CompletedScreenMoto';
import CompletedScreen from '../../common/components/redesignComponents/Purchase/CompletedScreen';
import axe from '../../services/axios-client/axiosClient';
import SentToCompanyAlert from './SentToCompanyAlert';
import ModificaDatiComponent from '../../common/components/elements/ModificaDatiComponent';
import BrokeraggioComponent from '../../common/components/redesignComponents/Purchase/BrokeraggioComponent';
import KoStatusAlert from './KoStatusAlert';
import PendingIssuanceAlert from './PendingIssuanceAlert';
import ConversationModal from '../../common/components/redesignComponents/Modal/ConversationModal';

function PurchaseMotoRequest() {
  const { requestToken } = useParams();
  const navigate = useNavigate();
  const state = useSelector((store) => store.purchases.moto);
  const {
    loading,
    quote,
    insuranceRequest,
    quoteStatus,
    backofficeUsers,
    rc_quotation,
    tutela_quotation,
    nonSignableDocs,
    requestedOptionalDocumentsNonSignable,
    // signableDocs,
    // requestedOptionalDocumentsSignable,
    risk_quotations,
    thread,
  } = state;

  const [showOptionalDocumentModal, setShowOptionalDocumentModal] = useState(false);

  const [supportMessage, setSupportMessage] = useState({
    subject: '',
    request_id: '',
    body: '',
    recipient: '',
  });
  const [loadingDocuments, setLoadingDocuments] = useState(false);
  const [showConversationModal, setShowConversationModal] = useState(false);

  const collectQuoteData = () => {
    purchaseInsuranceRequest(requestToken, 'moto', setSupportMessage);
  };

  const silentRefresh = () => purchaseInsuranceRequest(requestToken, 'moto', setSupportMessage, navigate, false);

  const checkDocuments = async () => {
    if (
      insuranceRequest.documents
      && insuranceRequest.documents.filter((doc) => doc.is_uploaded_valid == 0)
        .length > 0
    ) {
      generalAlertError('Elimina i documenti non validi prima di procedere!');
      return;
    }

    setLoadingDocuments(true);
    try {
      const response = await axe.post(
        `insurance-request/check-insurance-documents/${insuranceRequest.id}`,
      );

      if (
        response.status === 400
        && response.data?.data?.redirect_user === false
      ) {
        generalAlertError('Devi Caricare Tutti i Documenti Obbligatori!');
        setLoadingDocuments(false);
        return;
      }

      if (response.status === 200 && response?.data?.data?.code && response.data?.data?.code === 'direct_payment') {
        sonnerSuccessAlert('I documenti sono corretti, verrai reindirizzato alla pagina di pagamento!');
        setLoadingDocuments(false);
        collectQuoteData();
        return;
      }

      navigate('/');
      generalAlertSuccess('La pratica è completa, attendi nostro feedback!');
    } catch (error) {
      setLoadingDocuments(false);
      generalAlertError('Errore Interno');
    }
  };

  const agreedDocuments = async () => {
    try {
      const response = await axe.post(
        `/agree-to-upload-documents/${insuranceRequest.id}`,
        {
          agree_to_upload_document: 1,
        },
      );
      if (response.status !== 200) {
        generalAlertError('Non Accetato');
        return;
      }

      collectQuoteData();
    } catch (error) {
      //
    }
  };

  const checkIfAllNonSignableDocsAreUploaded = () => {
    let allUploaded = true;
    const allDocs = [
      ...insuranceRequest.documents.filter((d) => d.signable_document === 0),
      ...rc_quotation.documents.filter((d) => d.signable_document === 0),
    ];

    const nonSignaleDocTypeIds = nonSignableDocs.map((d) => d.id);

    for (let i = 0; i < allDocs.length; i++) {
      const document = allDocs[i];

      if (!nonSignaleDocTypeIds.includes(document.document_type_id)) {
        allUploaded = false;
      }
    }

    if (
      allDocs.length === 0
      || nonSignaleDocTypeIds.length !== allDocs.length
    ) {
      return false;
    }

    return allUploaded;
  };

  useEffect(() => {
    if (rc_quotation && rc_quotation.redirect_user === true) {
      navigate('/');
      generalAlertSuccess('La pratica è completa, attendi nostro feedback!');
    }
  }, [rc_quotation]);

  // useEffect(() => {
  //   if (loading === false && insuranceRequest.is_expired === true && insuranceRequest.request_token === requestToken) {
  //     navigate('/quote/motorcycle', {
  //       state: { requestToken: insuranceRequest.request_token },
  //     });
  //     generalAlertError(
  //       'È necessario compilare nuovamente il preventivo!',
  //       'Link e scaduto!',
  //     );
  //   }
  // }, [loading, insuranceRequest, requestToken]);

  useEffect(() => {
    collectQuoteData();
    motoGetBackofficeUsers();

    return () => {
      resetMotoPurchase();
    };
  }, []);

  useEffect(() => {
    if (loading === false && rc_quotation.prima_expired === true) {
      // navigate('/quote/motorcycle', {
      //   state: { requestToken: insuranceRequest.request_token },
      // });
      // generalAlertError(
      //   'È necessario compilare nuovamente il preventivo!',
      //   'Link e scaduto!',
      // );
      // ? DO nothing for the moment
    } else if (
      loading === false
      && rc_quotation.prima_link !== undefined
      && rc_quotation.prima_link !== null
    ) {
      if (quoteStatus !== 7) {
        window.open(
          `/redirect?url=${encodeURIComponent(rc_quotation.prima_link)}`,
        );
      }
    }
  }, [loading, rc_quotation]);

  const navigateBack = () => {
    navigate(`/quotes/moto/${insuranceRequest.request_token}`);
  };

  const acceptSelectedForBackoffice = () => {
    confirmSelectedForBackofficeQuote(rc_quotation.id, collectQuoteData);
  };

  const removeDocument = async (documentId) => {
    try {
      const response = await deleteDocument(documentId);

      if (response.status === 200) {
        collectQuoteData();
      }
    } catch (err) {
      // console.error(err);
    }
  };

  const removeOptionalDocument = async (documentId) => {
    try {
      const response = await apiDeleteOptionalDocument(documentId);

      if (response.status === 200) {
        collectQuoteData();
      }
    } catch (err) {
      // console.error(err);
    }
  };

  const openOptionalDocumentModal = () => {
    setShowOptionalDocumentModal(true);
  };

  useEffect(() => {
    if (insuranceRequest && insuranceRequest.redirect_user === true) {
      navigate('/');
      generalAlertSuccess('La pratica è completa, attendi nostro feedback!');
    }
  }, [insuranceRequest]);

  const downloadDocument = async (documentId) => {
    const response = await apiDownloadDocument(documentId);
    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.contents;
    alink.download = response.data.data.filename;
    alink.click();
  };

  const downloadOptionalDocument = async (documentId) => {
    const response = await apiDownloadOptionalDocument(documentId);
    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.contents;
    alink.download = response.data.data.filename;
    alink.click();
  };

  const sendBrokerageAmount = async (amount, skipCollect = false) => {
    // if (insuranceRequest?.insurance_request_extra_services?.length > 0) {
    //   generalAlertError('Non puoi aggiungere il brokeraggio se è già stato aggiunto un servizio.');
    //   return;
    // }

    if (skipCollect) {
      await updateBrokerage(rc_quotation.id, amount, () => { }, skipCollect);
    } else {
      await updateBrokerage(
        rc_quotation.id,
        amount,
        collectQuoteData,
        skipCollect,
      );
    }
  };

  const getTotal = () => {
    let rcTotalAmount = 0;
    let primaGuaranteesPrices = 0;
    const risksTotalAmount = 0;

    // if (risk_quotations && risk_quotations.length > 0) {
    //   for (let i = 0; i < risk_quotations.length; i++) {
    //     const item = risk_quotations[i];

    //     risksTotalAmount += rc_quotation.payment_frequency === 1 ? parseFloat(item.amount) : parseFloat(item.amount / rc_quotation.payment_frequency);
    //   }
    // }

    if (rc_quotation.company_id === 2) {
      rc_quotation.guarantees.forEach((guarantee) => {
        primaGuaranteesPrices
          += rc_quotation.payment_frequency === 1
            ? parseFloat(guarantee.amount)
            : parseFloat(guarantee.amount / rc_quotation.payment_frequency)
            || 0;
      });
    }

    rcTotalAmount = rc_quotation.payment_frequency === 1
      ? rc_quotation.amount
      : rc_quotation.amount / rc_quotation.payment_frequency;

    return parseFloat(
      rcTotalAmount + primaGuaranteesPrices + risksTotalAmount,
    ).toFixed(2);
  };

  useEffect(() => {
    if (rc_quotation !== null && rc_quotation.should_redirect === 1) {
      navigate(`/quotes/${insuranceRequest.request_token}`);
      generalAlertError(
        'Se vuoi selezionare un altro preventivo devi fare modifica dati!',
      );
    } else if (
      rc_quotation !== null
      && rc_quotation.preventivas_company_id !== null
      && rc_quotation.selected_for_backoffice === null
    ) {
      confirmAlertForBackofficeBrokerQuote(
        'Se confermi di procedere con questa quota e cambi idea devi fare modifica dati!',
        () => acceptSelectedForBackoffice(),
        navigate,
        insuranceRequest.request_token,
      );
    }
  }, [rc_quotation]);

  if (loading) {
    return <PageLoading />;
  }

  // const documentRequestsThatNeedSignature = [
  //   ...insuranceRequest.document_requests.filter((dr) => dr.document !== null && dr.document.signable_document === 1),
  //   ...quote.document_requests.filter((dr) => dr.document !== null && dr.document.signable_document === 1),
  // ];

  return (
    <>
      {showConversationModal && (
        <ConversationModal
          requestId={insuranceRequest?.id}
          threadId={thread?.thread_id}
          onClose={() => {
            setShowConversationModal(false);
            silentRefresh();
          }}
          onUpdated={() => silentRefresh()}
          location="quotation_moto_purchase"
        />
      )}
      <PurchaseStyles>
        {quoteStatus !== 7 && (
          <>
            <div className="container mt-0 gap-2 align-items-center justify-content-start mb-3">
              {![4, 6, 7].includes(quoteStatus) && (
                <ModificaDatiComponent navigateBack={navigateBack} />
              )}
              {/* <AutoStepper quoteStatus={quoteStatus} /> */}
              {rc_quotation && (
                <InfoBoxMoto
                  quote={quote}
                  rc_quotation={rc_quotation}
                  tutela_quotation={tutela_quotation}
                  insuranceRequest={insuranceRequest}
                  statues={purchase_statues}
                  quoteStatus={quoteStatus}
                  messagesModalData={{
                    backofficeUsers,
                    setSupportMessage,
                    supportMessage,
                    collectData: collectQuoteData,
                  }}
                  risk_quotations={risk_quotations}
                />
              )}
              <div className="d-flex align-items-center justify-content-end mt-3">
                <OutlineActionButton
                  type="button"
                  onClick={() => {
                    setShowConversationModal(true);
                    if (thread?.unreadMessages > 0) silentRefresh();
                  }}
                >
                  <ChatIcon />
                  Contatta il Backoffice
                  {thread?.unreadMessages > 0 && (
                  <ActionButtonBadge>
                    {thread.unreadMessages}
                    <span className="visually-hidden">messaggi non letti</span>
                  </ActionButtonBadge>
                  )}
                </OutlineActionButton>
              </div>
            </div>
            {rc_quotation && (
              <div className="container mt-0">
                {rc_quotation
                  && rc_quotation.company_id === 2
                  && rc_quotation.prima_link !== null
                  && !rc_quotation.indirect_prima_quote_process ? (
                    <Notice $tone="info" role="status">
                      <FontAwesomeIcon icon={faCircleInfo} />
                      <p>Verrai reindirizzato alla piattaforma Prima.it</p>
                    </Notice>
                  ) : (
                    <>
                      {quoteStatus === 1
                      || quoteStatus === 2
                      || quoteStatus === 5 ? (
                        <Stack>
                          {(rc_quotation.amount_changed === true
                        || rc_quotation.risk_quote_change === true) && (
                          <Notice $tone="warning">
                            <FontAwesomeIcon icon={faTriangleExclamation} />
                            <p>
                              <strong>Attenzione:</strong>
                              {' '}
                              L’importo totale del preventivo è
                              stato aggiornato. Di conseguenza, il brokeraggio è stato
                              modificato qualora superasse il limite massimo
                              consentito del 30% del valore del preventivo.
                            </p>
                          </Notice>
                          )}

                          <ConfirmCard className="skip-doc" $done={insuranceRequest.agree_upload_documents === 1}>
                            <p>
                              <FontAwesomeIcon
                                icon={insuranceRequest.agree_upload_documents === 1 ? faCircleCheck : faTriangleExclamation}
                              />
                              Importante
                            </p>
                            <label>
                              <input
                                type="checkbox"
                                checked={insuranceRequest.agree_upload_documents === 1}
                                disabled={insuranceRequest.agree_upload_documents === 1}
                                onClick={() => confirmAlert('', () => agreedDocuments())}
                              />
                              Dichiaro di aver adempiuto agli obblighi in ambito di consegna documentazione precontrattuale
                            </label>
                          </ConfirmCard>
                          {insuranceRequest?.redirect_prima_msg !== null && insuranceRequest?.redirect_prima === true && (
                          <Notice $tone="warning">
                            <FontAwesomeIcon icon={faTriangleExclamation} />
                            <div>
                              <p>
                                <strong>{insuranceRequest.redirect_prima_msg}</strong>
                              </p>
                              <p>
                                Premi il pulsante
                                {' '}
                                <strong>Invia Documenti</strong>
                                {' '}
                                per verificare il premio e procedere con il preventivo.
                              </p>
                            </div>
                          </Notice>
                          )}

                          {insuranceRequest.agree_upload_documents !== null
                        && (nonSignableDocs.length > 0
                          || requestedOptionalDocumentsNonSignable.length > 0) && (
                          <DocsCard
                            className={
                              checkIfAllNonSignableDocsAreUploaded()
                                ? 'document-all-uploaded-border'
                                : ''
                            }
                          >
                            <DocumentsResubmissionWarning quoteStatus={quoteStatus} />
                            <DocsHeader>
                              <StepBadge>1</StepBadge>
                              <DocsTitle>
                                Carica i
                                {' '}
                                <b>documenti</b>
                                {' '}
                                del cliente
                              </DocsTitle>
                            </DocsHeader>
                            {nonSignableDocs.length > 0 && (
                              <DocsGrid>
                                {nonSignableDocs.map((docType, index) => (
                                  <NonSignableDocumentComponent
                                    key={index}
                                    insuranceRequest={insuranceRequest}
                                    documentType={docType}
                                    downloadDocument={downloadDocument}
                                    removeDocument={removeDocument}
                                    rc_quotation={rc_quotation}
                                    collectQuoteData={collectQuoteData}
                                  />
                                ))}
                                {requestedOptionalDocumentsNonSignable.map(
                                  (document_request, index) => (
                                    <NonSIgnableDocumentRequestComponent
                                      key={index}
                                      document_request={document_request}
                                      removeOptionalDocument={
                                      removeOptionalDocument
                                    }
                                      downloadOptionalDocument={
                                      downloadOptionalDocument
                                    }
                                      collectQuoteData={collectQuoteData}
                                    />
                                  ),
                                )}
                                <OptionalTile>
                                  <OptionalBadge>Facoltativo</OptionalBadge>
                                  <img src={uploadIcon} alt="" />
                                  <button
                                    type="button"
                                    onClick={() => openOptionalDocumentModal()}
                                  >
                                    Richiedi di aggiungere un documento
                                  </button>
                                </OptionalTile>
                              </DocsGrid>
                            )}
                            {quoteStatus !== 5 && (
                              <DocsFooter>
                                <SubmitDocsButton
                                  type="button"
                                  onClick={() => confirmAlert(
                                    'Sei sicuro di voler procedere?',
                                    () => checkDocuments(),
                                  )}
                                  disabled={loadingDocuments}
                                >
                                  {loadingDocuments && <ButtonSpinner />}
                                  Invia Documenti
                                </SubmitDocsButton>
                              </DocsFooter>
                            )}
                          </DocsCard>
                          )}

                          {/* <div className="documents-status-step-five">
                          {rc_quotation.sign_later === null && (
                          <div className="row mt-3 ">
                            <div className="col-12 col-xxl-12 mt-2 mt-xxl-0">
                              <SkipSignedDocs className="skip-doc">
                                <p className="text-center">
                                  Vuoi Firmare Dopo?
                                </p>
                                <div className="d-flex justify-content-center align-items-center gap-3">
                                  <button
                                    className="btn btn-success border py-1 px-4"
                                    onClick={() => continueWithoutSignDocs()}
                                  >
                                    Si
                                  </button>
                                  <button
                                    className="btn btn-danger border py-1 px-4"
                                    onClick={() => continueWithSignDocs()}
                                  >
                                    No
                                  </button>
                                </div>
                              </SkipSignedDocs>
                            </div>
                          </div>
                          )}
                          {rc_quotation.sign_later === 1 && (
                          <div className="alert alert-success mt-3 border rounded-4">
                            Hai scelto di firmare i documenti più tardi.
                          </div>
                          )}
                          {rc_quotation.sign_later === 0 && (
                          <div className="row mt-3">
                            <div className="col-12 col-xxl-12 mt-2 mt-xxl-0">
                              <SignatureType
                                quote={rc_quotation}
                                insuranceRequest={insuranceRequest}
                                collectQuoteData={collectQuoteData}
                                documentRequestsThatNeedSignature={
                                  documentRequestsThatNeedSignature
                                }
                                signableDocs={signableDocs}
                                requestedOptionalDocumentsSignable={
                                  requestedOptionalDocumentsSignable
                                }
                              />
                            </div>
                          </div>
                          )}
                        </div> */}
                        </Stack>
                        ) : (
                          ''
                        )}

                      {/* {quoteStatus === 1 && (
                    <ServiceComponent
                      rc_quotation={rc_quotation}
                      getTotal={getTotal}
                      insuranceRequest={insuranceRequest}
                      collectQuoteData={collectQuoteData}
                      risk_quotations={risk_quotations}
                    />
                  )} */}
                      {quoteStatus === 1 && (
                      <BrokeraggioComponent
                        rc_quotation={rc_quotation}
                        sendBrokerageAmount={sendBrokerageAmount}
                        getTotal={getTotal}
                      />
                      )}
                      {quoteStatus === 4 && (
                      <WaitingForPaymentStatusV2
                        quote={quote}
                        rc_quotation={rc_quotation}
                        risk_quotations={risk_quotations}
                        tutela_quotation={tutela_quotation}
                        insuranceRequest={insuranceRequest}
                        collectQuoteData={collectQuoteData}
                        assistenza_quotation={null}
                        cristalli_quotation={null}
                        infortuni_conducente_quotation={null}
                        rivalsa_quotation={null}
                      />
                      )}
                      {quoteStatus === 6 && <PendingIssuanceAlert />}
                      {/* {quoteStatus === 6 && (
                      <div className="card-body">
                        <div className="row">
                          <div className="col-6 offset-3">
                            <div className="alert alert-success" role="alert">
                              <h4 className="alert-heading">
                                In Attesa Emissione
                              </h4>
                              <p>
                                Quando l'agente di backoffice carica la polizza,
                                riceverai una notifica e il contratto potrà essere
                                scaricato.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      )} */}
                      {quoteStatus === 9 && <KoStatusAlert insuranceRequest={insuranceRequest} />}
                      {quoteStatus === 8 && <SentToCompanyAlert />}
                    </>
                  )}
              </div>
            )}
          </>
        )}
        {showOptionalDocumentModal === true && (
          <OptionalDocumentModal
            quotationId={quote.id}
            closeModal={() => setShowOptionalDocumentModal(false)}
            collectQuoteData={collectQuoteData}
          />
        )}
        {quoteStatus === 7 && (
          <>
            <div className="mt-0 gap-2 align-items-center justify-content-start mb-3">
              {/* completedQUoteMotto */}
            </div>

            {/* <CompletedScreenMoto
              quote={quote}
              quoteStatus={quoteStatus}
              insuranceRequest={insuranceRequest}
              rc_quotation={rc_quotation}
              tutela_quotation={tutela_quotation}
              risk_quotations={risk_quotations}
            /> */}
            <CompletedScreen
              product="moto"
              quote={quote}
              quoteStatus={quoteStatus}
              insuranceRequest={insuranceRequest}
              rc_quotation={rc_quotation}
              tutela_quotation={tutela_quotation}
              risk_quotations={risk_quotations}
            />
          </>
        )}
      </PurchaseStyles>
    </>
  );
}

export default PurchaseMotoRequest;
